export default function getHtml(content = '') {
  return `
  <root> 
    ${content}
  </root>`;
}
